import BaseService from './BaseService'

class SmsService extends BaseService {
  constructor() {
    super('/sms')
  }

  /**
   * Check if a phone number has opted out of SMS.
   * @param {string} phone - Phone number (E.164 or national format)
   * @returns {Promise<{opted_out: boolean}>}
   */
  async getOptOutStatus(phone) {
    if (!phone || !String(phone).trim()) {
      return { opted_out: false }
    }
    const data = await this.customRequest('get', '/opt-out-status', { phone })
    return data ?? { opted_out: false }
  }
}

export const smsService = new SmsService()
